export function categoryBox() {
    $(document).on("click", ".accordion-toggle a", function (event) {
        event.preventDefault();
        let _this = $(this);
        _this.toggleClass("rotate");
        _this.parents(".category-box").find(".accordion-hide").slideToggle();
        if (_this.children("span").text() === "Show More") {
            _this.children("span").text("Show Less");
        } else {
            _this.children("span").text("Show More");
        }
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/category-box.js